import { render, staticRenderFns } from "./Widths.vue?vue&type=template&id=0d96ff7a&scoped=true"
import script from "./Widths.vue?vue&type=script&lang=js"
export * from "./Widths.vue?vue&type=script&lang=js"
import style0 from "./Widths.vue?vue&type=style&index=0&id=0d96ff7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96ff7a",
  null
  
)

export default component.exports